import { gql } from 'graphql-request';

import {
  AI_FLOW_QUERY_FRAGMENT,
  AI_PROMPT_QUERY_FRAGMENT,
} from './ai-prompts-gql';

export const TRANSCRIPTION_QUERY_FRAGMENT = `
{
  jobStatus
  audio {
    url
  }
  elementsJson {
    id
    url
  }
  waveformData {
    id
    url
  }
}`;

export const CUSTOMER_TYPE_QUERY_FRAGMENT = gql`
{
  id
  parentCustomerType {
    id
  }
  title
  clipProducerTemplates ${AI_FLOW_QUERY_FRAGMENT}
  clipProducerOverride
  blogTemplates ${AI_PROMPT_QUERY_FRAGMENT}
  blogOverride
  socialPostTemplates ${AI_PROMPT_QUERY_FRAGMENT}
  socialPostOverride
  emailTemplates ${AI_PROMPT_QUERY_FRAGMENT}
  emailOverride
  shareableImagesTemplates ${AI_PROMPT_QUERY_FRAGMENT}
  shareableImagesOverride
  talkingPointsTemplate ${AI_PROMPT_QUERY_FRAGMENT}
  talkingPointsOverride
  impactScoreTemplate ${AI_PROMPT_QUERY_FRAGMENT}
  graphicCategories { id }
  graphicCategoriesOverride
  graphicSubcategories { id }
  graphicSubcategoriesOverride
  videoTemplates { id }
  videoTemplatesOverride
}
`;

export const CUSTOMER_TYPE_DEFAULT_TEMPLATES_QUERY = gql`
  query getDefaultCustomerType {
    customerType(filter: { title: { eq: "Default" } })
      ${CUSTOMER_TYPE_QUERY_FRAGMENT}
  }
`;

export const CUSTOMER_TYPE_BY_ID_QUERY = gql`
  query getCustomerTypeById($id: ItemId!) {
    customerType(filter: { id: { eq: $id } })
      ${CUSTOMER_TYPE_QUERY_FRAGMENT}
  }
`;

// Resilient secondary query for the excludeFromGlobalTemplate /
// excludeFromGlobalCaptions flags on a CustomerType. Kept out of
// CUSTOMER_TYPE_QUERY_FRAGMENT so the primary showcase load (which embeds
// that fragment) is not blocked by schema drift while these Dato fields are
// being added. Callers default each flag to `false` on failure.
export const CUSTOMER_TYPE_TEMPLATE_FLAGS_QUERY = gql`
  query getCustomerTypeTemplateFlags($id: ItemId!) {
    customerType(filter: { id: { eq: $id } }) {
      id
      excludeFromGlobalTemplate
      excludeFromGlobalCaptions
    }
  }
`;
